import canSendDraft from './canSendDraft';

function sendDraft({
  caseReferrals,
  groupId: providerId,
  onSubmit,
  referral,
  user,
}) {
  return canSendDraft({
    caseReferrals, providerId, referral, user,
  }) ? {
    label: 'Edit and Send',
    description: 'Update the referral before sending it to another program.',
    icon: 'Forward',
    value: 'sendDraft',
    className: 'take-action-send-draft',
    action: onSubmit,
  } : null;
}

export default sendDraft;
